export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./editStaff.vue?vue&type=template&id=2630abb3&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/editStaff.vue?vue&type=template&id=2630abb3&
// module id = 1655
// module chunks = 0